import { Component } from "react";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { toastError, toastSuccess } from "../../../../utils/constants";
import { getBrandingOpportunityApprovalList_action, updateBrandingOpportunityApproval_action } from "../../../../actions/admin_module_action/manual_forms_admin_action/brandingOpportunityApproval_action/brandingOpportunityApproval_action";
import CommonModal from "../../../../utils/CommonModal";

class BrandingOpportunityApproval extends Component {
  //Initialized Constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      companyName: "",
      ApplicationList: [],
      isViewModalOpen: false,
      selectedComponent: null,
      selectedId: null,
    };
    this.getBrandingOpportunityApprovalList = this.getBrandingOpportunityApprovalList.bind(this);
    this.onCheckedAppliactions = this.onCheckedAppliactions.bind(this);
    this.onRemarkEnter = this.onRemarkEnter.bind(this);
    this.updateEDirectoryApproval = this.updateEDirectoryApproval.bind(this);
  }

  // On Component Load
  componentDidMount() {
    this.props.location.state != null &&
      this.props.location.state.companyName != "" &&
      this.getBrandingOpportunityApprovalList(this.props.location.state.companyName);

    this.setState({
      companyName:
        this.props.location.state != null && this.props.location.state.companyName
          ? this.props.location.state.companyName
          : "",
    });
  }

  // Get Exh Badges Appliactions
  getBrandingOpportunityApprovalList(companyName) {
    this.setState({ isLoading: true });
    this.props
      .getBrandingOpportunityApprovalList_action(companyName)
      .then((data) => {
        if (data.error != 1) {
          console.log("getBrandingOpportunityApprovalList Data", data.data);
          data.data.map((item) => {
            item.isSelected = false;
            item.isReadOnly = true;
          });
          this.setState({
            ApplicationList: data.data,
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Check Exh Badge Applications
  onCheckedAppliactions(e) {
    const { ApplicationList } = this.state;
    var checked = e.target.checked;
    var id = e.target.value;

    ApplicationList.length > 0 &&
      ApplicationList.map((data) => {
        if (checked) {
          if (id == data.BrandingOppotunityID) {
            data.isSelected = true;
            data.isReadOnly = false;
          }
        } else {
          if (id == data.BrandingOppotunityID) {
            data.isSelected = false;
            data.isReadOnly = true;
          }
        }
      });
    console.log("09000909090", ApplicationList);
    this.setState({});
  }

  /// On Remark Enter
  onRemarkEnter(e, id) {
    const { ApplicationList } = this.state;
    var value = e.target.value;
    var list = [...ApplicationList];
    list.length > 0 &&
      list.map((data) => {
        if (data.BrandingOppotunityID == id) {
          data.Remarks = value;
        }
      });
    console.log("0101010100101", list);
    this.setState({ ApplicationList: list });
  }

  // On View E-Directory
  onViewClick(ServiceName, id) {
    this.setState({
      isViewModalOpen: true,
      selectedComponent: ServiceName,
      selectedId: id,
    });
  }

  // On Update Visa Approval
  updateEDirectoryApproval(e, key) {
    const { ApplicationList, companyName } = this.state;
    var applicationList = ApplicationList.filter((item) => item.isSelected == true);
    var list;
    // checked Application List data Preparing to store
    var list = [];
    applicationList.map((data) => {
      var mapData = {
        BrandingOppotunityID: parseInt(data.BrandingOppotunityID),
        Remark: data.Remarks,
      };
      list.push(mapData);
    });
    const isCheckedRemark = list.every((item) => item.Remark != "" && item.Remark != null);
    if (list.length > 0) {
      if (key == 2 ? isCheckedRemark : true) {
        this.setState({ isLoading: true });
        this.props
          .updateBrandingOpportunityApproval_action(key == 1 ? true : false, list)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toastSuccess(
                `Branding Opportunity Form ${key == 1 ? "Approval" : "Disapproval"} Successfully!`
              );
              setTimeout(() => {
                this.getBrandingOpportunityApprovalList(companyName);
              }, 1000);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Please Enter Remark");
      }
    } else {
      toastError("Select Atleast One Application");
    }
  }

  onBackClick() {
    this.props.navigate("/brandingOpportunityAdmin");
  }

  render() {
    const { isLoading, ApplicationList } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <AdminDrawer />
        <div>
          <>
            <div className="with-dr-container">
              <div className="main-container">
                <div className="row m-0">
                  <div className="breadcrumb-scroll-fixed">
                    <h6 className="mb-0 p-2 text-white">
                      Branding Opportunity And Advertising Form Approval
                    </h6>
                  </div>
                </div>
              </div>
              <div className="admin-top-space pt-2">
                <div className="row mb-6 m-0">
                  {/* <div className="col-lg-12 mt-2">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Login Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="jindal rectifiers"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Badge Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Balance Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div> */}
                  <div className="table-responsive">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                      <thead>
                        <tr>
                          <th className="text-center">Sr.No</th>
                          <th className="text-center">Select</th>
                          <th className="text-center">Company Name</th>
                          <th>Name</th>
                          <th className="text-center">Country</th>
                          <th className="text-center">Status</th>
                          <th>Remarks</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ApplicationList.length > 0 &&
                          ApplicationList.map((data, index) => (
                            <tr key={data.BrandingOppotunityID}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-center">
                                <input
                                  type="checkbox"
                                  checked={data.isSelected}
                                  value={data.BrandingOppotunityID}
                                  disabled={
                                    data.StatusID == "Approved" || data.StatusID == "Disapproved"
                                  }
                                  onChange={(e) => this.onCheckedAppliactions(e)}
                                />
                              </td>
                              <td className="text-center">{data.CompanyName}</td>

                              <td>{data.Name}</td>
                              <td className="text-center">{data.Country}</td>
                              <td className="text-center">{data.StatusID}</td>
                              <td>
                                <form>
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ height: 40 }}
                                    disabled={data.isReadOnly}
                                    value={data.Remarks}
                                    onChange={(e) =>
                                      this.onRemarkEnter(e, data.BrandingOppotunityID)
                                    }
                                  />
                                </form>
                              </td>
                              <td className="text-center">
                                <i
                                  class="fa fa-eye grid-icon"
                                  onClick={(e) =>
                                    this.onViewClick(
                                      "Branding Opportunity",
                                      data.BrandingOppotunityID
                                    )
                                  }
                                ></i>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="main-container mt-2">
                    <div className="mt-1 mb-4 approval-actions">
                      {ApplicationList.some(data => data.StatusID == "Applied") &&
                      <>
                      <a
                        className="btn btn-aqua"
                        type="submit"
                        onClick={(e) => this.updateEDirectoryApproval(e, 1)}
                      >
                        Approve
                      </a>
                      <a
                        className="btn btn-red m-1"
                        type="submit"
                        onClick={(e) => this.updateEDirectoryApproval(e, 2)}
                      >
                        Reject
                      </a>
                      </>}
                      <a
                        className="btn btn-gray m-1"
                        type="submit"
                        onClick={(e) => this.onBackClick()}
                      >
                        Back
                      </a>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
        <CommonModal
          isOpen={this.state.isViewModalOpen}
          componentName={this.state.selectedComponent}
          componentProps={{
            is_View: true,
            FormID: this.state.selectedId,
          }}
          onClose={() => this.setState({ isViewModalOpen: false })}
        />
      </>
    );
  }
}
export default withRouter(connect(null, { getBrandingOpportunityApprovalList_action, updateBrandingOpportunityApproval_action })(BrandingOpportunityApproval))